import { Box, Stack } from "@mui/system";
import {
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { transformFormData } from "../../DataStoreHelpers/dataStoreHelpers";

const CreateSave = () => {
  const { createQueryFormDataInput } = useSelector(
    (state: any) => state.dataStoreReq
  );

  const editableOutputData = useSelector(
    (state: any) => state.dataStoreReq.editableOutputValues
  );

  const inputValues = transformFormData(createQueryFormDataInput);

  return (
    <>
      <Box>
        <Box mt={2}>
          <Accordion
            sx={{
              minHeight: "48px",
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: "0px", // Removes the extra margin when expanded
              },
            }}
          >
            <AccordionSummary
              sx={{
                minHeight: "48px !important",
                // boxShadow: "0px 7px 8px -3px rgba(0,0,0,0.3)",
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">Input Fields Review</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  overflowX: "auto",
                  display: "flex",
                  scrollbarWidth: "thin",
                }}
              >
                {inputValues.map((input: any, i: number) => (
                  <Box
                    key={i}
                    mb={1}
                    sx={{
                      minWidth: "100%",
                      borderRight: "1px solid #E0E0E0",
                    }}
                    mx={1}
                  >
                    <Stack
                      flexDirection={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography component="span">{input.title}</Typography>
                      <FormGroup>
                        <Stack flexDirection={"row"}>
                          {input.fields[4] && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="secondary"
                                  checked={input.fields[4].value}
                                  size="small"
                                  disabled
                                />
                              }
                              label="UNIQ"
                            />
                          )}

                          {input.fields[5] && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="secondary"
                                  checked={input.fields[5].value}
                                  size="small"
                                  disabled
                                />
                              }
                              label="Not Mutable"
                            />
                          )}
                        </Stack>
                      </FormGroup>
                    </Stack>
                    <Grid container spacing={1} mt={1}>
                      {inputValues[i].fields?.map((field: any, index: any) => (
                        <Grid size={4} key={index}>
                          <TextField
                            label={field.label}
                            disabled
                            fullWidth
                            variant="standard"
                            value={field.value}
                            sx={{
                              "& .MuiInput-underline:before": {
                                borderBottomStyle: "none !important",
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            sx={{
              minHeight: "48px",
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: "0px", // Removes the extra margin when expanded
              },
            }}
          >
            <AccordionSummary
              sx={{
                minHeight: "48px !important",
                // boxShadow: "0px 7px 8px -3px rgba(0,0,0,0.3)",
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">Output Fields Review</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                sx={{
                  overflowX: "auto",
                  display: "flex",
                  scrollbarWidth: "thin",
                }}
              >
                {editableOutputData?.map((output: any, i: number) => (
                  <Box
                    key={i}
                    mb={1}
                    sx={{
                      minWidth: "100%",
                      borderRight: "1px solid #E0E0E0",
                    }}
                    mx={1}
                  >
                    <Stack
                      flexDirection={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography component="span">{output.name}</Typography>
                      <FormGroup>
                        <Stack flexDirection={"row"}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="secondary"
                                size="small"
                                disabled
                              />
                            }
                            label="UNIQ"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="secondary"
                                size="small"
                                disabled
                              />
                            }
                            label="Not Mutable"
                          />
                        </Stack>
                      </FormGroup>
                    </Stack>
                    <Grid container spacing={1} mt={1}>
                      {Object.entries(output).map(([key, value]) => {
                        if (["id", "name", "value_for_test"].includes(key))
                          return null;
                        if (value === "null") return null;

                        return (
                          <Grid minHeight={104}>
                            <TextField
                              label={key.charAt(0).toUpperCase() + key.slice(1)}
                              fullWidth
                              variant="standard"
                              value={value}
                              disabled
                              sx={{
                                "& .MuiInput-underline:before": {
                                  borderBottom: "none",
                                },
                                "& .MuiInput-underline:after": {
                                  borderBottom: "none",
                                },
                              }}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
          <Typography color="error" mt={2} fontSize={12} display={"none"}>
            Saving request to Datastore requirements are not met. You must mark
            a minimum of 2 fields as UNIQ and 1 field as Not Mutable. Please
            Edit the desired fields or Create Task Structure.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default CreateSave;
